import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const VID_KEY = "netroy-vid";

function getVisitorId() {
  try {
    let v = localStorage.getItem(VID_KEY);
    if (!v) {
      v = (crypto.randomUUID && crypto.randomUUID()) || `v_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VID_KEY, v);
    }
    return v;
  } catch {
    return "anon";
  }
}

export const PageTracker = () => {
  const location = useLocation();
  const last = useRef(null);

  useEffect(() => {
    const path = location.pathname || "/";
    if (last.current === path) return;
    last.current = path;
    const utm = new URLSearchParams(location.search).get("utm_source");
    api.post("/analytics/track", {
      path,
      visitor_id: getVisitorId(),
      referrer: document.referrer || "",
      utm_source: utm,
    }).catch(() => {});
  }, [location.pathname, location.search]);

  return null;
};
